export default __webpack_public_path__ + "assets/a20276762af950c382b087f83f7fa1a9.svg";